export const ADD = 'notificationAdd';
export const DELETE = 'notificationDelete';
